export function findMostOccurrences(numbers) {
  let counted = numbers.reduce((acc, curr) => {
    if (curr in acc) {
      acc[curr]++
    } else {
      acc[curr] = 1
    }

    return acc
  }, {})

  return Object.keys(counted).reduce((a, b) => (counted[a] > counted[b] ? a : b))
}



// WEBPACK FOOTER //
// ./src/lib/findMostOccurrences.js